const React = require('react');
const PropTypes = require('prop-types');
const { formatText } = require('core/i18n').i18n;
const RiskDial = require('./RiskDial');
const RiskDotList = require('./RiskDotList');
const RiskTriangle = require('./RiskTriangle');
require('./RiskIndicator.scss');


const RiskIndicator = ({ index }) => (
    <div className="risk-indicator">
        <RiskDotList index={index} />
        <RiskDial index={index} />
        <RiskTriangle index={index} />
        <div className="risk-indicator__legend">
            <div className="risk-indicator__legend__risk-low">
                <b>{formatText('fundsCard-lowerRiskTitle')}</b><br />
                <p>{formatText('fundsCard-lowerRiskDescription')}</p>
            </div>
            <div className="risk-indicator__legend__risk-high">
                <b>{formatText('fundsCard-higherRiskTitle')}</b><br />
                <p>{formatText('fundsCard-higherRiskDescription')}</p>
            </div>
        </div>
    </div>
);


RiskIndicator.propTypes = {
    index: PropTypes.number.isRequired,
};

module.exports = RiskIndicator;
